<div class="flex-container">
	<div class="flex-column"></div>
	<div *ngIf="labyrinthe && page >= 0 && page <= 2 && currentValidPath"
			[style.height.px]="labProp.height" [style.width.px]="labProp.width"
			class="labyrinth-container" id="labyrinth">
		<div *ngFor="let row of labyrinthe[page], let y = index, let first = first, let last = last"
			nz-row class="labyrinth-row"
			[ngClass]="{ 'first-row': first, 'last-row': last }"
		>
			<div *ngFor="let element of row, let x = index, let ifirst = first, let ilast = last"
			nz-col class="labyrinth-col"
			[ngClass]="{ 'first-element': ifirst, 'last-element': ilast }"
			>
				<div class="labyrinth-element" id="element-{{x}}-{{y}}"
					[ngClass]="{
						'empty-tile': element === stdTile.emptyTile,
						'valid-tile': element === stdTile.validTile,
						'start-tile': element === stdTile.startTile,
						'exit-tile': element === stdTile.exitTile,
						'visited': element !== stdTile.emptyTile && currentValidPath[y][x]?.visited
					}"
					(tap)="processTappedObject({x: x, y: y})"
					(click)="processTappedObject({x: x, y: y})"
				></div>
			</div>
		</div>
	</div>
	<div class="flex-column big-text">
		<table *ngIf="isDevMode && page >= 0" class="dev-table">
			<tr><th></th><th><b>Status</b></th></tr>
			<tr><td></td><td>{{ started ? 'erfasse...' : 'warte...' }}</td></tr>
			<tr><th></th><th><b>Fehler</b></th></tr>
			<tr><td>Probe: </td><td>{{results[page].probefehler}}</td></tr>
			<tr><td>Wiederholung: </td><td>{{results[page].wiederholungsfehler}}</td></tr>
		</table>
	</div>
</div>
<div class="extrabuttons buttonrow replaceButtonrow" *ngIf="page <= 2" >
	<div class="left-buttons">
	</div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="secondary" class="big-button right-one" (click)="cancelLabyrinth()">
			{{ 'actions.cancel' | translate }}
		</button>
		<button nz-button nzType="primary" class="big-button right-one"
						(mousedown)="loadNextLabyrinth()" [disabled]="!finished || page >= 2"
						[style.visibility]="page < 2 ? 'visible' : 'hidden'"
		>
			{{ ((page < 2) ? 'workflow.next_labyrinth' : 'actions.next') | translate }}
		</button>
	</div>
</div>
